import { render, staticRenderFns } from "./CardSaldoProjetos.vue?vue&type=template&id=2b1fd6cc&"
import script from "./CardSaldoProjetos.vue?vue&type=script&lang=js&"
export * from "./CardSaldoProjetos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports